import React from 'react';
import { DASH } from '../Campaigns/CampaignChartCard';

/** Shown instead of any figures when the selected interval has no data for the person / team. */
export default function AttainmentNoData({
  intervalLabel,
  who,
  title,
  message,
}: {
  intervalLabel: string;
  who?: string;
  title?: string;
  message?: string;
}) {
  return (
    <div
      style={{
        background: DASH.surface,
        border: `1px solid ${DASH.border}`,
        borderRadius: DASH.radius,
        padding: '28px 18px',
        textAlign: 'center',
        color: DASH.textDim,
      }}
    >
      <div style={{ fontWeight: 700, color: DASH.text, marginBottom: 4 }}>
        {title ?? `No attainment data for ${intervalLabel || 'this interval'}`}
      </div>
      <div style={{ fontSize: '0.875rem' }}>
        {message ??
          `${who ? `${who} has` : 'There is'} no goal data recorded in ${intervalLabel || 'the selected interval'}. Pick another interval to see attainment.`}
      </div>
    </div>
  );
}
